export default {
  add_announcement: "Add Announcement",
  edit_announcement: "Edit Announcement",
  detail_announcement: "Detail Announcement",
  search_announcement: "Search Announcement",
  max_length_title: "Maximum 128 characters",
  my_announcement: "My Announcement"
};
